import {
  Controller
} from "@hotwired/stimulus";

export default (function() {
  var _Class;

  _Class = class extends Controller {
    validate(event) {
      var departureDate, fields, firstInvalid, hasError, i, input, len, message, name, returnDate;
      hasError = false;
      firstInvalid = null;
      fields = [["destination", "Informe o destino da viagem."], ["departure", "Informe a data de ida."], ["return", "Informe a data de volta."], ["travelers", "Informe pelo menos 1 viajante."]];
      for (i = 0, len = fields.length; i < len; i++) {
        [name, message] = fields[i];
        input = this[`${name}Target`];
        this.clearError(input);
        if ((input == null) || !input.value || (name === "travelers" && Number(input.value) < 1)) {
          this.showError(input, message);
          hasError = true;
          if (firstInvalid == null) {
            firstInvalid = input;
          }
        }
      }
      departureDate = this.hasDepartureTarget && this.departureTarget.value ? new Date(this.departureTarget.value) : null;
      returnDate = this.hasReturnTarget && this.returnTarget.value ? new Date(this.returnTarget.value) : null;
      if ((departureDate != null) && (returnDate != null) && returnDate < departureDate) {
        this.showError(this.returnTarget, "A data de volta deve ser após a ida.");
        hasError = true;
        if (firstInvalid == null) {
          firstInvalid = this.returnTarget;
        }
      }
      if (hasError) {
        event.preventDefault();
        if ((firstInvalid != null) && typeof firstInvalid.focus === "function") {
          return firstInvalid.focus();
        }
      }
    }

    showError(input, message) {
      var error;
      if (input == null) {
        return;
      }
      input.setAttribute("aria-invalid", "true");
      error = document.getElementById(`${input.id}-error`);
      if (error == null) {
        return;
      }
      error.textContent = message;
      return error.classList.add("is-visible");
    }

    clearError(input) {
      var error;
      if (input == null) {
        return;
      }
      input.setAttribute("aria-invalid", "false");
      error = document.getElementById(`${input.id}-error`);
      if (error == null) {
        return;
      }
      error.textContent = "";
      return error.classList.remove("is-visible");
    }

  };

  _Class.targets = ["destination", "departure", "return", "travelers"];

  return _Class;

}).call(this);
